import { defineMessages } from "react-intl";

const planMessages = defineMessages({
  enterprise1: {
    id: "limitAlerts.enterprise.1",
    defaultMessage: "AI-Powered Route Optimization",
  },
  enterprise2: {
    id: "limitAlerts.enterprise.2",
    defaultMessage: "200 Monthly Lead Searches ",
  },
  enterpriseSubtitle: {
    id: "limitAlerts.enterprise.subtitle",
    defaultMessage: "Advanced capabilities for scaling organizations",
  },
  leader1: {
    id: "limitAlerts.leader.1",
    defaultMessage: "Unlimited users",
  },
  leader2: {
    id: "limitAlerts.leader.2",
    defaultMessage: "125 Monthly Lead Searches",
  },
  leaderSubtitle: {
    id: "limitAlerts.leader.subtitle",
    defaultMessage: "Advanced capabilities for scaling organizations",
  },
  midMarket1: {
    id: "limitAlerts.midMarket.1",
    defaultMessage: "Team of up to 25 users",
  },
  midMarket2: {
    id: "limitAlerts.midMarket.2",
    defaultMessage: "75 Monthly Lead Searches",
  },
  midMarketSubtitle: {
    id: "limitAlerts.midMarket.subtitle",
    defaultMessage: "Essential customization, perfect for growing teams!",
  },
});

export const planNameToInfo = {
  Enterprise: {
    extraPoints: [planMessages.enterprise1, planMessages.enterprise2],
    link: "https://share.hsforms.com/1QViO6J9YTOCzx4QNxQiwpg3is1h",
    popular: true,
    subtitle: planMessages.enterpriseSubtitle,
  },
  "Industry Leader": {
    extraPoints: [planMessages.leader1, planMessages.leader2],
    link: "https://share.hsforms.com/1UcRliuPGQoytvRdHvH9k2g3is1h",
    popular: false,
    subtitle: planMessages.leaderSubtitle,
  },
  "Mid-Market Sales": {
    extraPoints: [planMessages.midMarket1, planMessages.midMarket2],
    link: "https://share.hsforms.com/19dGgbN_aRV64s_Kq29p1qw3is1h",
    popular: false,
    subtitle: planMessages.midMarketSubtitle,
  },
} as const;
